// Firebase utility for table structure and data for Experienced Profiles
import { db } from '../../firebase';
import { collection, doc, getDoc, setDoc } from 'firebase/firestore';

const TABLE_STRUCTURE_KEY = 'tableStructure-ExperiencedProfiles';
const TABLE_DATA_KEY = 'tableData-ExperiencedProfiles';

export async function getTableStructure() {
  const docRef = doc(collection(db, 'customTables'), TABLE_STRUCTURE_KEY);
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data().structure : [];
}

export async function saveTableStructure(structure) {
  const docRef = doc(collection(db, 'customTables'), TABLE_STRUCTURE_KEY);
  await setDoc(docRef, { structure });
}

export async function getTableData() {
  const docRef = doc(collection(db, 'customTables'), TABLE_DATA_KEY);
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data().data : [];
}

export async function saveTableData(data) {
  const docRef = doc(collection(db, 'customTables'), TABLE_DATA_KEY);
  await setDoc(docRef, { data });
}
